import React, { useState, useEffect } from "react";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { Qrcode } from "./components/Qrcode";
import { Videos } from "./components/Videos";
import { VideoData } from "./components/VideoData";
import { About } from "./components/about";
import { Contact } from "./components/contact";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <VideoData />
      <Qrcode data={landingPageData.Features} />
      <Videos />
      <Contact data={landingPageData.Contact} />
    </>
  );
};

export default Home;
